<div class="activeUser">
  <div class="header-div d-flex align-items-center">
    <div class="d-flex align-items-center">
      <div class="logo-div">
        <img src="/assets/images/Piqet_NewLogo.svg" alt="Logo" />
      </div>
      <div class="go-back-div" routerLink="/register">
        <i class="bi bi-arrow-left"></i>
        <span>Go back</span>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-center mb-3 mt-5">
    <div class="d-flex flex-column justify-content-start">
      <div class="title-div">
        <p class="title-text m-0">Please confirm your email</p>
        <p class="title-text">and start using PIQET.</p>
        <p class="sub-title-text">
          We sent an email to <span class="email-text">{{ email }}</span>
        </p>
      </div>

      <div>
        <p class="title-text">Next steps</p>

        <!-- Trial Registration Steps -->
        <ng-container *ngIf="isTrialRegistration">
          <p class="sub-title-text">1. Verify your email</p>
          <p class="content-text">Click on the link in the email to verify your account.</p>

          <p class="sub-title-text">2. Verification in progress</p>
          <p class="content-text">
            Your organization is being reviewed. You’ll be notified once it’s complete (1-2 days).
          </p>

          <p class="sub-title-text">3. Start using PIQET</p>
          <p class="content-text">
            After verification is complete, log in to PIQET and start exploring features.
          </p>
        </ng-container>

        <ng-container *ngIf="!isTrialRegistration && !hasSharedLink">
          <p class="sub-title-text">1. Verify your account</p>
          <p class="content-text">Click on the link in the email to verify your account.</p>

          <p class="sub-title-text">2. Start using PIQET</p>
          <p class="content-text">Log in to PIQET and start exploring features.</p>
        </ng-container>

        <ng-container *ngIf="!isTrialRegistration && hasSharedLink">
          <p class="sub-title-text">1. Verify your account</p>
          <p class="content-text">Click on the link in the email to verify your account.</p>

          <p class="sub-title-text">2. Admin will verify your account</p>
          <p class="content-text">Your administrator will approve and activate your access.</p>

          <p class="sub-title-text">3. Start using PIQET</p>
          <p class="content-text">Log in to PIQET and start exploring features.</p>
        </ng-container>
      </div>

      <div class="">
        <div class="text-center mb-3">
          <a class="linkText" [routerLink]="['/login']" [queryParams]="{ email: email }"
            >Login here</a
          >
        </div>
        <div class="copyright">
          <a class="linkText" href="http://www.lifecycles.com.au/" target="_blank"
            >© Life Cycle Strategies Pty Ltd</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
